import TYPES from '../actions/types';

const INITIAL_STATE = {
  id: 0,
  reference: null,
  name: null,
  telephone: null,
  email: null,

  loadingPostForm: false,
  postDataError: { message: '', errors: [] },
}

export default function(state = INITIAL_STATE, action) {
  switch(action.type) {
    case TYPES.setDataFormDelete:
      return {
        ...state,
        id: action.payload.id,
        reference: action.payload.id,
        name: action.payload.name,
        telephone: action.payload.telephone,
        email: action.payload.email,
        postDataError: { message: '', errors: [] },
      }

    case TYPES.loadingFormDelete:
      return { ...state, loadingPostForm: !state.loadingPostForm };

    case TYPES.formPostDeleteError:
      return { ...state, postDataError: action.payload.data };

    default:
      return state;
  }
}
